import About from "@/components/about";
import Catering from "@/components/catering";
import Faq from "@/components/faq";
import HeroBanner from "@/components/home-banner";
import Menu from "@/components/menu";
import Recognized from "@/components/recognized";
import { SEO } from "@/components/shared/seo";
import { StructuredData } from "@/components/shared/structuredData";
import Video from "@/components/video";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import "@/app/globals.scss"; // Global styles
import Layout from "@/components/shared/layout";

export default function Home() {
  return (
    <>

      <StructuredData />
      <SEO />

      <Layout>
        <HeroBanner></HeroBanner>

        <About></About>

        <Catering></Catering>

        <Recognized></Recognized>

        <Menu></Menu>

        <Video></Video>

        <Faq></Faq>

        <div className="back-button">
          <a
            href="https://www.tablacuisine.com/" target="_blank"
            className="text-center tracking-[.1em] uppercase text-[14px] bg-red-800 hover:bg-red-900 px-5 py-3 text-white inline-block"
          >
            Visit Tablacuisine
          </a>
        </div>

        <div id="fixed-social">
          <div>
            <a href="https://www.instagram.com/tablaindiancatering" aria-label="instagram" className="fixed-instagrem" target="_blank">
              <FaInstagram className='text-md' /> <span>Instagram</span></a>
          </div>
          <div>
            <a href="https://m.facebook.com/tablaindiancatering" aria-label="facebook" className="fixed-facebook" target="_blank">
              <FaFacebook className='text-md' /> <span>Facebook</span></a>
          </div>
          {/* <div>
            <a href="https://x.com/i/flow/login?redirect_after_login=%2Ftablacuisine" aria-label="twitter" className="fixed-twitter" target="_blank"> <FaTwitter className='text-md' /> <span>Twitter</span></a>
          </div> */}
        </div>
      </Layout>

    </>
  );
}

// export const getStaticProps: GetStaticProps = async () => {
//   try {
//     const [blogResponse] = await Promise.all([
//       axios.get(
//         "https://api.tablacuisine.com/api/website/activity?pagination=true&type=BLOG&page=1&limit=5"
//       ),
//     ]);

//     return {
//       props: {
//         blogs: blogResponse.data?.data || [],
//       },
//       revalidate: 21600,
//     };
//   } catch (error) {
//     console.error("Error fetching data:", error);
//     return {
//       props: { order: [], users: [] },
//     };
//   }
// };
